import { useGraphqlQuery } from "@bsm/component"
import { TUserStudentsResponse } from "@bsm/graphql"
import { StudentsQuery } from "../queries/StudentsQuery"

export const useGetStudentsQuery = (data?: Record<string, any>, suspense?: boolean) => {
    return useGraphqlQuery<StudentsQuery, TUserStudentsResponse>(new StudentsQuery({ data }), { enabled: data !== undefined, suspense })
}